<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage jejuYview"
  >
    <header-area />

    <div class="worksView">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">Simple And Easy<br />Fit Lifestyle For You!</div>
            <div class="workSlogan mobile">Simple And Easy<br />Fit Lifestyle<br />For You!</div>
            <div class="workTopDay">
              <p>오리온 제주용암수 온라인플랫폼 구축</p>
              <ul>
                <li>Web site &amp; App</li>
                <li>2019.12.01</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://www.jejuyongamsoo.com/" target="_blank" class="siteAddr"
                >https://www.jejuyongamsoo.com/</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/jejuwater"
                    title="당신의 라이프스타일에 맞춘 간편하고 쉬운 온라인 플랫폼, 오리온 제주용암수"
                    hashtags="플립커뮤니케이션즈,오리온,제주용암수온라인플랫폼"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/jejuwater"
                    title="당신의 라이프스타일에 맞춘 간편하고 쉬운 온라인 플랫폼, 오리온 제주용암수"
                    hashtags="플립커뮤니케이션즈,오리온,제주용암수온라인플랫폼"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt"
            ><marquee-text :duration="16"
              >&nbsp;Simple And Easy Fit Lifestyle For You!</marquee-text
            ></span
          >
          <img src="@/assets/images/works_view/jeju_y/jeju_y_visual.jpg" alt="" />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          오리온은 자사 프리미엄 미네랄워터 브랜드인 ‘제수용암수’를 새롭게 출시함에 따라 해당 제품의
          성공적인 시장 진입 방법에 대해 고민했습니다. 우리는 사용자가 제주용암수를 지속적으로
          이용하고 자발적으로 홍보할 수 있게 하는 방안은 없는지, 구독 사용자들을 계속 유지할 수 있는
          방법은 무엇인지, 또한 해당 제품의 온라인 플랫폼을 손쉽게 경험해볼 수 있게 하는 방안은
          무엇일지에 대해 고민한 결과를 토대로 제주용암수 온라인 플랫폼을 구축하게 되었습니다.
        </div>
      </div>
    </div>

    <div class="wideConts">
      <!-- section_1 -->
      <div class="jySection1">
        <div class="worksView">
          <div class="contsBox">
            <div class="jyTitle web">
              <span class="jyNum">BACKGROUND</span>
              <strong class="jyTxt">
                효과적인 온라인 플랫폼을 위한 고민의 시작
              </strong>
            </div>

            <div class="jyTitle mobile">
              <span class="jyNum">BACKGROUND</span>
              <strong class="jyTxt"> 효과적인 온라인 플랫폼을<br />위한 고민의 시작 </strong>
            </div>

            <div class="jyConText">
              오리온은 사용자들이 제한된 시간 안에서 가치 있는 소비를 할 수 있도록 개개인의 소비
              패턴과 변화에 맞춘 ‘가정배달 서비스’를 도입하고자 했습니다. 이와 더불어 과열된 생수
              시장에 성공적으로 진입하기 위해 브랜드와 제품을 빠르게 홍보할 수 있는 판매 채널을
              구축하고자 했습니다.
            </div>

            <div class="talkArea">
              <div class="web">
                <img src="@/assets/images/works_view/jeju_y/con1.png" alt="" />
              </div>
              <div class="mobile">
                <img src="@/assets/images/works_view/jeju_y/con1_m.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //section_1 -->

      <!-- section_2 -->
      <div class="jySection2">
        <div class="worksView">
          <div class="contsBox">
            <div class="jyTitle web">
              <span class="jyNum">KEYWORD</span>
              <strong class="jyTxt">
                제작 배경을 바탕으로 키워드 수집
              </strong>
            </div>

            <div class="jyTitle mobile">
              <span class="jyNum">KEYWORD</span>
              <strong class="jyTxt"> 제작 배경을 바탕으로<br />키워드 수집 </strong>
            </div>
          </div>
        </div>

        <div class="worksView">
          <div class="contsBox">
            <div class="keywordArea">
              <div class="webAndTb">
                <div>
                  <img src="@/assets/images/works_view/jeju_y/con2_hand.png" alt="" />
                </div>
              </div>
              <div class="onlyMob">
                <div>
                  <img src="@/assets/images/works_view/jeju_y/con2_hand_m.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //section_2 -->

      <!-- section_3 -->
      <div class="jySection3">
        <div class="projectGoal1">
          <!-- PROJECT GOAL_1 -->
          <div class="worksView">
            <div class="contsBox">
              <div class="jyTitle web">
                <span class="jyNum">PROJECT GOAL</span>
                <strong class="jyTxt">
                  온라인 플랫폼의 핵심 목표 Easy, Simple, Fit!
                </strong>
              </div>

              <div class="jyTitle mobile">
                <span class="jyNum">PROJECT GOAL</span>
                <strong class="jyTxt"> 온라인 플랫폼의 핵심 목표<br />Easy, Simple, Fit! </strong>
              </div>

              <div class="jyConText">
                제주용암수 온라인 플랫폼은 누구나 쉽고 간편하게 서비스를 이용할 수 있도록 각
                개인별로 맞춤화된 서비스를 제공한다는 목표를 근간으로 기획됐으며, 빠른 유지 보수
                대응이 가능하도록 Vue.js 신기술을 도입해 제작됐습니다.<br />온라인에서 해당 제품을
                효과적으로 주문/결제/판매할 수 있도록 쉽고 간편한 주문 프로세스를 구현했으며, 사용자
                행동 패턴에 맞춰 변화하는 홈 화면을 통해 사용자에게 중요한 콘텐츠가 우선시 될 수
                있도록 구성하고, 간편한 정기 배송 예약이 가능하도록 프로세스를 단순화했습니다.
              </div>
            </div>
          </div>

          <div class="txtView">
            <div class="txtBox">
              <div class="pGoalCyArea">
                <ul>
                  <li class="pGoalCy1">
                    <div>
                      <p>
                        <strong>Easy</strong>
                        <span>쉽고</span>
                      </p>
                    </div>
                  </li>
                  <li class="pGoalCy2">
                    <div>
                      <p>
                        <strong>Simple</strong>
                        <span>간편하게</span>
                      </p>
                    </div>
                  </li>
                  <li class="pGoalCy3">
                    <div>
                      <p>
                        <strong>Fit</strong>
                        <span>맞추다</span>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="pGoalSlogan">
                <div class="web">
                  <div class="pGsloganArea">
                    <div class="gradationTxt">
                      <span>Simple And Easy</span>
                      <span>Fit Lifestyle For You!</span>
                    </div>
                    <div class="pGsloganInfo">
                      당신의 라이프스타일에 맞춘 간편하고 쉬운 온라인 플랫폼
                    </div>
                  </div>
                </div>

                <div class="mobile">
                  <div class="pGsloganArea">
                    <div class="gradationTxt">
                      <span>Simple And Easy</span>
                      <span>Fit Lifestyle</span>
                      <span>For You!</span>
                    </div>
                    <div class="pGsloganInfo">
                      당신의 라이프스타일에 맞춘<br />간편하고 쉬운 온라인 플랫폼
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="platformImg">
            <div class="web">
              <img src="@/assets/images/works_view/jeju_y/con3_mockup.jpg" alt="" />
            </div>
            <div class="mobile">
              <img src="@/assets/images/works_view/jeju_y/con3_mockup_m.jpg" alt="" />
            </div>
          </div>
        </div>

        <div class="projectGoal2">
          <!-- PROJECT GOAL_2 -->
          <div class="worksView">
            <div class="contsBox">
              <div class="icoJejuApp">
                <img src="@/assets/images/works_view/jeju_y/ico_app.png" alt="" />
              </div>

              <div class="jyTitle web">
                <strong class="jyTxt">
                  사용자 행동 패턴에 맞춰 변화하는 홈 화면
                </strong>
              </div>

              <div class="jyTitle mobile">
                <strong class="jyTxt"> 사용자 행동 패턴에 맞춰<br />변화하는 홈 화면 </strong>
              </div>

              <div class="jyConText">
                사용자 상태에 따라 홈 화면 구성과 대표 문구를 다르게 구성해 개인화된 서비스를 경험할
                수 있도록 제작했습니다. 또한 각 사용자의 상태별로 중요한 콘텐츠가 우선적으로
                노출되도록 구성해 제품 구매 활성화 및 자발적 홍보 연계가 이뤄질 수 있도록
                구현했습니다.
              </div>
            </div>
          </div>

          <div class="pG2ConArea">
            <div class="pG2ConBox">
              <ul>
                <li class="pG2ConLi1">
                  <div>
                    <img src="@/assets/images/works_view/jeju_y/app1.png" alt="" />
                  </div>
                  <p>로그인 전</p>
                </li>
                <li class="pG2ConLi2">
                  <div>
                    <img src="@/assets/images/works_view/jeju_y/app2.png" alt="" />
                  </div>
                  <p>혜택1 완료 후</p>
                </li>
                <li class="pG2ConLi3">
                  <div>
                    <img src="@/assets/images/works_view/jeju_y/app3.png" alt="" />
                  </div>
                  <p>혜택2 완료 후</p>
                </li>
              </ul>
              <span class="greenCyBg" />
            </div>
          </div>
        </div>

        <div class="projectGoal3">
          <!-- PROJECT GOAL_3 -->
          <div class="pGoal3_1 worksView">
            <div class="pGoal3_1All contsBox">
              <div class="pGoal3_1_1">
                <div class="icoPlan">
                  <img src="@/assets/images/works_view/jeju_y/ico_plan.png" alt="" />
                </div>

                <div class="jyTitle">
                  <strong class="jyTxt"> 라이프스타일에 맞춘<br />정기배송 예약 프로세스 </strong>
                </div>

                <div class="jyConText">
                  정기배송 제품, 수량, 주기 등 선택 조건에 맞춰 누구나 쉽고 간편하게 정기배송 예약
                  서비스를 이용할 수 있도록 제작했습니다.
                </div>
              </div>

              <div class="pGoal3_1_2">
                <img src="@/assets/images/works_view/jeju_y/con3_plan_app.png" alt="" />
              </div>
            </div>
          </div>

          <div class="pGoal3_2">
            <div class="worksView">
              <div class="contsBox different">
                <div class="jyTitle">
                  <strong class="jyTxt">
                    컨트롤이 쉬운 정기배송
                  </strong>
                </div>

                <div class="jyConText">
                  바쁜 일상을 보내는 사용자의 라이프스타일을 고려해 간편하게 정기배송 여부를 조정할
                  수 있도록 온 &middot; 오프 시스템을 구현했습니다.
                </div>
              </div>
            </div>

            <div class="controlBtn">
              <div class="cBtnArea">
                <div class="">
                  <!-- 클래스 on이 있을때 버튼활성화  -->
                  <a href="javascript:;" />
                  <span />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="projectGoal4">
          <!-- PROJECT GOAL_4 -->
          <div class="pGoal4_1 worksView">
            <div class="pGoal4_1All contsBox">
              <div class="pGoal4_1_1">
                <div class="icoTruck">
                  <img src="@/assets/images/works_view/jeju_y/ico_truck.png" alt="" />
                </div>

                <div class="jyTitle web">
                  <strong class="jyTxt">
                    주문 상태를 알려주는 배송 현황
                  </strong>
                </div>

                <div class="jyTitle mobile">
                  <strong class="jyTxt"> 주문 상태를 알려주는<br />배송 현황 </strong>
                </div>

                <div class="jyConText">
                  현재 배송 현황과 배송 예정일을 홈 화면에 배치해 사용자가 궁금해하는 현재 배송
                  상태를 직관적으로 보여줍니다.
                </div>
              </div>

              <div class="pGoal4_1_2">
                <p>
                  <img src="@/assets/images/works_view/jeju_y/con3_delivery_txt.png" alt="" />
                </p>
                <span>
                  <img src="@/assets/images/works_view/jeju_y/con3_delivery.png" alt="" />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="projectGoal5">
          <!-- PROJECT GOAL_5 -->
          <div class="worksView humpLine">
            <div class="contsBox">
              <div class="jyTitle">
                <strong class="jyTxt"> 재방문을 유도하는<br />친구 추천과 쿠폰 </strong>
              </div>

              <div class="jyConText">
                정기배송 4회차마다 무료 혜택을 제공하는 친구 추천 기능과 쿠폰 기능을 구현해 사용자가
                자발적으로 제품 및 서비스를 홍보하고 신규 사용자의 방문을 유도시키는 마케팅
                플랫폼으로서의 기능을 강화했습니다.
              </div>
            </div>
          </div>

          <div class="worksView">
            <div class="contsBox">
              <div class="pGoal5Img">
                <div class="pGoal5Img_L">
                  <div class="pG5Img pG5Img1">
                    <img src="@/assets/images/works_view/jeju_y/con3_return_visit1.png" alt="" />
                  </div>
                </div>
                <div class="pGoal5Img_R">
                  <div class="pG5Img pG5Img2">
                    <img src="@/assets/images/works_view/jeju_y/con3_return_visit2.png" alt="" />
                  </div>
                  <div class="pG5Img pG5Img3">
                    <img src="@/assets/images/works_view/jeju_y/con3_return_visit3.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="projectGoal6">
          <!-- PROJECT GOAL_6 -->
          <div class="worksView">
            <div class="contsBox">
              <div class="jyTitle web">
                <strong class="jyTxt">
                  다채널에서 동일한 브랜드, 서비스 경험 제공
                </strong>
              </div>

              <div class="jyTitle mobile">
                <strong class="jyTxt"> 다채널에서 동일한 브랜드,<br />서비스 경험 제공 </strong>
              </div>

              <div class="jyConText">
                모바일 플랫폼 구축을 바탕으로 각 화면들을 PC에 최적화했습니다. 모바일 앱/웹에서
                제공하는 서비스를 PC에서도 동일하게 구현함으로써 사용 편의성을 높이고, 사용자
                모두에게 동일한 서비스와 브랜드 경험을 제공할 수 있도록 제작했습니다.
              </div>
            </div>
          </div>

          <div class="worksView">
            <div class="webPage">
              <div class="webPgPoint">
                <img src="@/assets/images/works_view/jeju_y/con3_web_page.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //section_3 -->

      <!-- section_4 -->
      <div class="jySection4">
        <div class="worksView">
          <div class="contsBox">
            <div class="jyTitle">
              <span class="jyNum">WORK TOOL</span>
              <strong class="jyTxt">
                처음 만나는 Vue.js
              </strong>
            </div>

            <div class="jyConText">
              오리온 제주용암수는 버튼, 폼 양식, 다이얼로그 등 반복적인 컴포넌트들이 주요 화면을
              이루기 때문에 머티리얼 가이드 시스템 기반의 UI 컴포넌트 Vuetify를 도입했습니다.<br />Vuetify
              가이드에 맞춰 디자인을 구성한 결과, 불필요한 작업시간을 줄이고 프런트 화면에 배치된
              주요 기능에 집중할 수 있었습니다. 또한 개발 파트에서 역시 개발 난이도를 낮추고 운영을
              용이하게 하는 등 각 파트별로 작업의 효율성을 극대화하는 긍정적인 효과를 얻었습니다.
            </div>
          </div>
        </div>

        <div class="jySect4">
          <div class="worksView">
            <div class="jySect4All contsBox different">
              <div class="jySect4_1">
                <p>
                  <img src="@/assets/images/works_view/jeju_y/con4_img1.png" alt="" />
                </p>
                <span>
                  <img src="@/assets/images/works_view/jeju_y/con4_img2.png" alt="" />
                </span>
              </div>

              <div class="jySect4_2 web">
                <img src="@/assets/images/works_view/jeju_y/con4_inp.jpg" alt="" />
              </div>
              <div class="jySect4_2 mobile">
                <img src="@/assets/images/works_view/jeju_y/con4_inp.jpg" alt="" />
              </div>
            </div>
          </div>

          <span class="rulerBg" />
        </div>
      </div>
      <!-- //section_4 -->
    </div>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-kdb' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">KDB산업은행 차세대 채널 구축</strong>
          <strong class="mobile">KDB산업은행<br />차세대 채널 구축</strong>
        </div>

        <div class="engBg jejuYEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";

export default {
  mixins: [common],
  name: "Main",
  /* head: {
    title: {
      inner: '오리온 제주용암수'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data() {
    return {
      meta: {
        siteName: "오리온 제주용암수 홈페이지 | 플립커뮤니케이션즈",
        title: "오리온 제주용암수 홈페이지",
        desc: "오리온 제주용암수",
        keywords:
          "제주용암수, 온라인 플랫폼, 웹 사이트, 앱, 미네랄 워터, 프리미엄 브랜드, 가정 배달 서비스, 생수 시장, 주문 프로세스, 정기 배송 예약, 사용자 경험, 사용자 행동 패턴, 간편한 서비스, 자발적 홍보, 모바일 플랫폼",
        url: "https://www.pulip.com/works/jejuY",
        img: "https://www.pulip.com/pulip-logo.jpg"
      }
    };
  },
  computed: {
    ...mapState("common", {
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    })
  },
  methods: {
    doCopy() {
      this.$copyText("https://www.pulip.com/works/jejuY").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    }
  },
  mounted() {}
};
</script>
